import { useMonarchRule } from "../MonarchRulesProvider";
import { ExecEdDetailPageProps, ExecEdDetailPageTestResult } from "./types";
import validateHex from "@/utils/functions/validateHex";

const CUSTOM_RULE_ID = "execEdDetailPage";

export default function useExecEdDetailPageTest(): ExecEdDetailPageTestResult {
  const { isLoading, value } = useMonarchRule<{
    data: ExecEdDetailPageProps;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading) {
    return {
      isLoading,
      data: {
        countdownBanner: {
          text: "",
          position: "",
          theme: "",
        },
        certificateFactoid: {
          factoidText: "",
          position: 0,
          showFactoidDesktop: false,
          showFactoidMobile: false,
          factoidHeader: "",
          factoidIcon: "",
          variantColor: "primary",
          showFactoid: false,
        },
        stickyBannerCta: {
          ctaText: "",
          bottomCtaText: "",
          showDesktop: false,
          showMobile: false,
        },
        heroBadges: {
          position: "",
          badges: [],
        },
        sectionsOrder: {
          about: 0,
          curriculum: 0,
          certificate: 0,
          facts: 0,
          brochure: 0,
          whyGetSmarter: 0,
          promoBanner: 0,
        },
        expandMobileAccordianByDefault: false,
        bannerColorHex: "",
        eventing: {
          conversionType: "",
        },
        routeFlag: false,
      },
    };
  }

  return {
    isLoading,
    variant: value?.data?.redesignV7 === undefined ? "control" : "test",
    data: {
      countdownBanner: {
        text: value?.data?.countdownBanner?.text,
        position: value?.data?.countdownBanner?.position,
        theme: value?.data?.countdownBanner?.theme,
      },
      certificateFactoid: {
        factoidText: value?.data?.certificateFactoid?.factoidText,
        position: value?.data?.certificateFactoid?.position,
        showFactoidDesktop: value?.data?.certificateFactoid?.showFactoidDesktop,
        showFactoidMobile: value?.data?.certificateFactoid?.showFactoidMobile,
        factoidHeader: value?.data?.certificateFactoid?.factoidHeader,
        factoidIcon:
          value?.data?.certificateFactoid?.factoidIconName ??
          value?.data?.certificateFactoid?.factoidIcon,
        tooltip: value?.data?.certificateFactoid?.tooltip,
        variantColor: value?.data?.certificateFactoid?.variantColor,
        showFactoid: value?.data?.certificateFactoid?.showFactoid,
      },
      stickyBannerCta: {
        ctaText: value?.data?.stickyBannerCta?.ctaText,
        bottomCtaText: value?.data?.stickyBannerCta?.bottomCtaText,
        showDesktop: value?.data?.stickyBannerCta?.showDesktop,
        showMobile: value?.data?.stickyBannerCta?.showMobile,
      },
      heroBadges: {
        position: value?.data?.heroBadges?.position,
        badges: value?.data?.heroBadges?.badges || [],
      },
      sectionsOrder: {
        about: value?.data?.sectionsOrder?.about,
        curriculum: value?.data?.sectionsOrder?.curriculum,
        certificate: value?.data?.sectionsOrder?.certificate,
        facts: value?.data?.sectionsOrder?.facts,
        brochure: value?.data?.sectionsOrder?.brochure,
        whyGetSmarter: value?.data?.sectionsOrder?.whyGetSmarter,
        promoBanner: value?.data?.sectionsOrder?.promoBanner,
      },
      hideStickyNav: value?.data?.hideStickyNav,
      expandMobileAccordianByDefault:
        value?.data?.expandMobileAccordianByDefault || false,
      bannerColorHex: value?.data?.bannerColorHex
        ? validateHex(value.data?.bannerColorHex)
        : undefined,
      bannerTextColorHex: value?.data?.bannerTextColorHex
        ? validateHex(value.data?.bannerTextColorHex)
        : undefined,
      showCourseSnapshot: value?.data?.showCourseSnapshot,
      eventing: {
        conversionType: value?.data?.eventing?.conversionType || "",
      },
      routeFlag: value?.data?.routeFlag,
      redesignV7: value?.data?.redesignV7 ?? {},
    },
  };
}
